var map = {
	"./A Positive Update on Cheaters.md": [
		2794,
		794
	],
	"./Emotes Everywhere Winners.md": [
		2186,
		186
	],
	"./Holi Dhamaka 1.9.0 Update Patch Notes.md": [
		5913,
		913
	],
	"./Holi Dhamaka 1.9.0 Update Schedule.md": [
		1877,
		877
	],
	"./Introducing Device Ban.md": [
		1960,
		960
	],
	"./KRAFTON, Inc. launches exclusive Christmas events.md": [
		2015,
		15
	],
	"./Pop A Pataka Winners.md": [
		9139,
		139
	],
	"./Privacy Policy Revisions.md": [
		2416,
		416
	],
	"./Sanctions Against Cheaters.md": [
		65,
		65
	],
	"./Server Optimization Maintenance Notice.md": [
		4546,
		546
	],
	"./Story Of The Duo Winners.md": [
		4925,
		925
	],
	"./Tag Your Squad Contest Winners.md": [
		5942,
		942
	],
	"./Tag Your Squad.md": [
		296,
		296
	],
	"./We Heard You.md": [
		8293,
		293
	],
	"./[December Update] Known Issues Updated.md": [
		2093,
		93
	],
	"./[July Update] Patch Notes.md": [
		2233,
		233
	],
	"./[September Update] Known Issue Updated.md": [
		8789,
		789
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1377;
module.exports = webpackAsyncContext;